import React from 'react';
import { Eye, Heart, MessageSquare, TrendingUp } from 'lucide-react';

const RecentActivityWidget = ({ inquiries = [], properties = [] }) => {
  // Combinar y ordenar actividad
  const activities = [
    ...inquiries.slice(0, 3).map(inq => ({
      type: 'consulta',
      icon: MessageSquare,
      color: 'text-green-600',
      bg: 'bg-green-50',
      title: `Nueva consulta de ${inq.name}`,
      subtitle: inq.property_title || 'Consulta general',
      time: inq.created_at
    })),
    ...properties
      .filter(p => p.view_count > 0)
      .sort((a, b) => b.view_count - a.view_count)
      .slice(0, 2)
      .map(prop => ({
        type: 'vista',
        icon: Eye,
        color: 'text-blue-600',
        bg: 'bg-blue-50',
        title: `${prop.view_count} vistas`,
        subtitle: prop.title,
        time: prop.created_at
      }))
  ].sort((a, b) => new Date(b.time) - new Date(a.time)).slice(0, 5);

  if (activities.length === 0) {
    return (
      <div className="bg-background border border-border rounded-lg p-6">
        <h3 className="text-lg font-bold mb-4 flex items-center gap-2">
          <TrendingUp className="w-5 h-5 text-primary" />
          📊 Actividad Reciente
        </h3>
        <p className="text-sm text-muted-foreground text-center py-4">
          No hay actividad reciente
        </p>
      </div>
    );
  }

  return (
    <div className="bg-background border border-border rounded-lg p-6">
      <h3 className="text-lg font-bold mb-4 flex items-center gap-2">
        <TrendingUp className="w-5 h-5 text-primary" />
        📊 Actividad Reciente
      </h3>
      
      <div className="space-y-3">
        {activities.map((activity, idx) => {
          const Icon = activity.icon;
          return (
            <div key={idx} className={`${activity.bg} border border-${activity.color.replace('text-', '')}/20 rounded-lg p-3 flex items-start gap-3`}>
              <div className="mt-0.5">
                <Icon className={`w-4 h-4 ${activity.color}`} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold truncate">{activity.title}</p>
                <p className="text-xs text-muted-foreground truncate">{activity.subtitle}</p>
                <p className="text-xs text-muted-foreground mt-1">
                  {new Date(activity.time).toLocaleDateString('es-MX', { 
                    day: 'numeric', 
                    month: 'short',
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RecentActivityWidget;
